export default __webpack_public_path__ + "static/media/marker-green.de61c46e.png";